var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftMenu"},_vm._l((_vm.leftMenus),function(leftItem,idx){return _c('li',{key:idx,class:[
      'menu-item',
      _vm.isActiveInner === leftItem.anchorId ? 'menu-item--active' : ''
    ],on:{"click":function($event){return _vm.gotoHandle(leftItem.anchorId)}}},[_vm._v("\n    "+_vm._s(leftItem.title)+"\n    "),_c('div',{staticClass:"articleTitle"},[_vm._v("\n      "+_vm._s(leftItem.articleTitle)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }